export const AMOUNT_REGEX_STR = "^[0-9]+(.[0-9]{1,2})?$";
export const INTEGER_REGEX_STR = "^\\d*$";
export const US_ZIPCODE_REGEX_STR = "^\\d{5}$";

export const getUpdatedQuestions = ({ question, value, questions }) => {
  const updatedQuestions = questions.map((q) => {
    if (q.id !== question.id) return q;

    const answer = {
      ...q.answer,
      answer: {
        ...q.answer.answer,
        [q.id]: value,
      },
    };
    const updatedQuestion = {
      ...q,
      answer,
    };
    return updatedQuestion;
  });

  return updatedQuestions;
};
